/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const chatbot_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M22 13.5c.607.456 1 1.182 1 2 0 .818-.393 1.544-1 2m-20-4c-.607.456-1 1.182-1 2 0 .818.393 1.544 1 2M12 7a8 8 0 1 1-.002 16.001A8 8 0 0 1 12 7Zm0 0V4m0 0a1.5 1.5 0 1 1-.002-2.999A1.5 1.5 0 0 1 12 4ZM8.312 16.491h.346m6.674 0h.346m-6.941 0c0 .184-.16.244-.248.244-.092 0-.252-.06-.252-.244 0-.196.16-.256.252-.256.088 0 .248.06.248.256Zm7.02 0c0 .184-.16.244-.248.244-.092 0-.252-.06-.252-.244 0-.196.16-.256.252-.256.088 0 .248.06.248.256Z"
    />
  </svg>
)
export default chatbot_medium
